import isEqual from 'lodash/isEqual';

/**
 * Compare a given state with a given initial state and return an object with
 * initial state values removed. This ensures proper merging of hydrated store.
 * @see https://github.com/kirill-konshin/next-redux-wrapper#app-and-getserversideprops-or-getstaticprops-at-page-level
 * @deprecated
 */
export function reconcileState<S>(state: S, initialState: S): S {
  const newState = { ...state };

  for (const prop in newState) {
    if (isEqual(newState[prop], initialState[prop])) {
      delete newState[prop];
    }
  }

  return newState;
}
